export default "__VITE_ASSET__DY$jO02N__"